var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { transition: false, "max-width": 600, persistent: false },
      model: {
        value: _vm.opened,
        callback: function ($$v) {
          _vm.opened = $$v
        },
        expression: "opened",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline" }),
          _c("v-card-text"),
          _c(
            "v-card-actions",
            [
              _vm._t("actions", function () {
                return [
                  _c("v-spacer"),
                  _c("v-btn", { attrs: { text: "", color: "grey darken-2" } }, [
                    _vm._v("cancel"),
                  ]),
                  _c(
                    "v-btn",
                    { attrs: { text: "", color: "primary darken-2" } },
                    [_vm._v("OK")]
                  ),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }